import React from 'reactn';
import {
    withStyles,
    Box,
    Typography,
    Tooltip
} from '@material-ui/core';

import { Loader } from '../../..';
import styles from '../index.style';
import { CustomCheckbox } from '../../../../custom-checkbox';

const getRowClassName = (classes, isSuperAdmin, isLastRow) =>
    [classes.level1Box, !isSuperAdmin && isLastRow ? classes.noBorderBottom : ''].filter(Boolean).join(' ');

const FeatureToggleRow = ({
    boxId,
    checkboxId,
    classes,
    heading,
    descriptions,
    isLastRow,
    isSuperAdmin,
    isLoading,
    isChecked,
    onToggle,
}) => (
    <Box
        component="div"
        id={boxId}
        justifyContent="space-between"
        className={getRowClassName(classes, isSuperAdmin, isLastRow)}
        display="flex"
    >
        <Box component="div" textAlign="left">
            <Typography className={classes.boxHeading1}>{heading}</Typography>
            {descriptions.map((description) => (
                <Typography key={description} id="checkbox-text" className={classes.subHeading1}>
                    {description}
                </Typography>
            ))}
        </Box>
        <Tooltip title="">
            <Box display="flex" alignItems="center" component="div">
                {isLoading && <Loader />}
                <CustomCheckbox id={checkboxId} onChange={onToggle} checked={isChecked} />
            </Box>
        </Tooltip>
    </Box>
);

/**
 * Preview / MVP re-entry plan toggles for the Re-Entry Preparation settings section.
 * Renders rows only — parent accordion owns the section chrome.
 */
const CasePlan = (props) => {
    const { classes, reentryPreview = {}, reentryPlan = {} } = props;

    return (
        <>
            <FeatureToggleRow
                boxId="reentry-preview-box-wrapper"
                checkboxId="reentry-preview-status-checkbox"
                classes={classes}
                heading="Preview"
                descriptions={[
                    'If turned on, staff at this location can access Preview re-entry plans.',
                ]}
                isLastRow={false}
                isSuperAdmin={props.isSuperAdmin}
                isLoading={props.reentryPreviewStatusLoader}
                isChecked={reentryPreview.status}
                onToggle={() => {
                    props.updateSettingsState(
                        'feature',
                        { status: !reentryPreview.status },
                        'features',
                        'reentryPreview',
                        'reentryPreviewStatusLoader',
                    );
                }}
            />
            <FeatureToggleRow
                boxId="reentry-plan-box-wrapper"
                checkboxId="reentry-plan-status-checkbox"
                classes={classes}
                heading="MVP"
                descriptions={[
                    'If turned on, staff at this location can access MVP re-entry plans.',
                ]}
                isLastRow={true}
                isSuperAdmin={props.isSuperAdmin}
                isLoading={props.reentryPlanStatusLoader}
                isChecked={reentryPlan.status}
                onToggle={() => {
                    props.updateSettingsState(
                        'feature',
                        { status: !reentryPlan.status },
                        'features',
                        'reentryPlan',
                        'reentryPlanStatusLoader',
                    );
                }}
            />
        </>
    );
};

export default withStyles(styles)(CasePlan);
